import type { IconNode } from '../types';

/**
 * @name scissors-hair-comb
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNiAyQzUgNSA3IDUgNiA4IiAvPgogIDxwYXRoIGQ9Ik0xMCAyYy0xIDMgMSAzIDAgNiIgLz4KICA8Y2lyY2xlIGN4PSI0IiBjeT0iMjAiIHI9IjIiIC8+CiAgPHBhdGggZD0iTTUuNCAxOC42IDggMTYiIC8+CiAgPHBhdGggZD0iTTEwLjggMTMuMiAxNCAxMCIgLz4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjIwIiByPSIyIiAvPgogIDxwYXRoIGQ9Im0yIDEwIDguNiA4LjYiIC8+CiAgPHBhdGggZD0iTTE4IDJoMmEyIDIgMCAwIDEgMiAydjE2YTIgMiAwIDAgMS0yIDJoLTIiIC8+CiAgPHBhdGggZD0iTTE4IDZoNCIgLz4KICA8cGF0aCBkPSJNMTggMTBoNCIgLz4KICA8cGF0aCBkPSJNMTggMTRoNCIgLz4KICA8cGF0aCBkPSJNMTggMThoNCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/scissors-hair-comb
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const scissorsHairComb: IconNode = [
  ['path', { d: 'M6 2C5 5 7 5 6 8', key: 'm4r6l8' }],
  ['path', { d: 'M10 2c-1 3 1 3 0 6', key: 'gcvugc' }],
  ['circle', { cx: '4', cy: '20', r: '2', key: '6kqj1y' }],
  ['path', { d: 'M5.4 18.6 8 16', key: '18335i' }],
  ['path', { d: 'M10.8 13.2 14 10', key: '8pwnbu' }],
  ['circle', { cx: '12', cy: '20', r: '2', key: '144qzu' }],
  ['path', { d: 'm2 10 8.6 8.6', key: 'uqw9b8' }],
  ['path', { d: 'M18 2h2a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2', key: 'ab8lh9' }],
  ['path', { d: 'M18 6h4', key: '66u95g' }],
  ['path', { d: 'M18 10h4', key: '1fqhjb' }],
  ['path', { d: 'M18 14h4', key: '16spdh' }],
  ['path', { d: 'M18 18h4', key: '187mio' }],
];

export default scissorsHairComb;
